import React from 'react'

const Contact = () => {
  return (
    <div name='contact' className='w-full h-screen bg-[#0a192f] flex justify-center items-center p-4'>
        <form method='POST' action="https://getform.io/f/42a9d71c-ddab-41ef-a2e8-2aa919e1cedb" className='flex flex-col max-w-[600px] w-full'>
            <div>
                <p className='text-4xl font-bold inline border-b-4 border-[#cd853f] text-gray-300'>Contato</p>
                <p className='text-gray-300 py-4'>Preencha o formulário ou me mande um email! - gpaespinheiro@gmail.com</p>
            </div>
            <input className='bg-[#fff] p-2' type="text" placeholder='Name' name='name'/>
            <input className='my-4 p-2 bg-[#fff]' type='email' placeholder='Email' name='email' />
            <textarea className='bg-[#fff] p-2' name='message' rows='10' placeholder='Message'></textarea>
            <button className='text-white border-2 hover:bg-[#cd853f] hover:border-[#cd853f] px-4 py-3 my-8 mx-auto flex items-center'>Let's colaborate</button>
        </form>
    </div>
  )
}

export default Contact